<template>
  <!-- prettier-ignore -->
  <ul class="file-list linklist__download-list">
    <li
      v-for="file in files"
      :key="file.id"
      class="file-list__item"
    >
      <file-item
        :file="file"
        v-bind="$attrs"
      />
    </li>
  </ul>
</template>

<script>
import FileItem from '@/components/Form/File/FileItem'

export default {
  name: 'List',

  components: {
    FileItem,
  },

  props: {
    files: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="postcss">
.file-list {
  padding-left: 0;

  &__item {
    list-style: none;
    line-height: 20px;
  }
}
</style>
